import { render } from "./App.vue?vue&type=template&id=13c61fd2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=13c61fd2&lang=scss"
script.render = render

export default script